export default __webpack_public_path__ + "static/media/doctorspeicon.7bdad7a8.svg";